import { createAction, props } from '@ngrx/store';

export const updateVirtualEventActivity = createAction(
  '[VirtualEvent] Update VirtualEventActivity',
  props<any>() 
);

export const clearVirtualEventActivity = createAction(
  '[VirtualEvent] Clear VirtualEventActivity'
);
